import React from 'react'
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state'
import { t } from '@lingui/macro'

import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Tooltip from '@mui/material/Tooltip'

import LanguageIcon from '@mui/icons-material/Language'

import { languagePolicy } from '@/language-policy'
import { useLanguage } from '@/hooks/useLanguage'
import { HeaderIconButton } from './HeaderIconButton'
import { useMeasurementUnitSystem } from '@/hooks/useMeasurementUnitSystem'
import { useUpdateMyProfileMutation } from '@/core/services/auth'
import { useSnackbar } from 'notistack'
import { getApiErrorMessage } from '@/utils/errors'

export function Language() {
  const { enqueueSnackbar } = useSnackbar()
  const lang = useLanguage()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { setUnitSystem } = useMeasurementUnitSystem()

  const [updateMyProfile] = useUpdateMyProfileMutation()
  const handleChangeLanguage = async (language: string) => {
    try {
      await updateMyProfile({ userInfo: { language } }).unwrap()
      setUnitSystem(language === 'en-US' || language === 'en' ? 'imperial' : 'metric')
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error, t`An error occurred while changing the language`), { variant: 'error' })
    }
  }

  if (languagePolicy.allowedLanguages.length < 2) return null

  return (
    <PopupState variant="popover" popupId="languages">
      {(popupState) => (
        <React.Fragment>
          <Tooltip title={t`Languages`}>
            <HeaderIconButton aria-label="language selector" color="secondary" {...bindTrigger(popupState)} isMobile={isMobile}>
              <LanguageIcon />
            </HeaderIconButton>
          </Tooltip>
          <Menu {...bindMenu(popupState)}>
            {languagePolicy.allowedLanguages.map((language) => (
              <MenuItem
                key={language}
                onClick={() => {
                  handleChangeLanguage(language)
                  popupState.close()
                }}
                sx={[lang === language && { fontWeight: 'bold' }]}
              >
                {language.toUpperCase()}
              </MenuItem>
            ))}
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  )
}
